import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Hash, Store } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import api from '../../services/api';

export default function StoreCard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get(`/v1/stores/${id}`);
        if (res?.data) setStore(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, [id]);

  if (loading) return (
    <div style={{ textAlign: 'center', padding: 80 }}>
      <div style={{ width: 32, height: 32, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />
      <span style={{ color: '#94A3B8', fontSize: 13 }}>Загрузка...</span>
    </div>
  );
  if (!store) return <div style={{ textAlign: 'center', padding: 80, color: '#EF4444', fontWeight: 500 }}>Магазин не найден</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button variant="ghost" icon={<ArrowLeft size={15} />} onClick={() => navigate('/stores')} size="sm">Назад</Button>
        <span style={{ color: '#CBD5E1' }}>/</span>
        <span style={{ fontSize: 13, color: '#64748B' }}>{store.name}</span>
      </div>

      <Card>
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{
            width: 68, height: 68, borderRadius: 18,
            background: 'linear-gradient(135deg, #00CEEE, #009995)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            boxShadow: '0 4px 12px rgba(0,206,238,0.3)',
          }}>
            <Store size={30} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>{store.name}</h2>
            <div style={{ display: 'flex', gap: 16, marginTop: 8, flexWrap: 'wrap' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#64748B' }}><Hash size={13} />{store.source_code}</span>
              {store.address && <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#64748B' }}><MapPin size={13} />{store.address}</span>}
            </div>
            <div style={{ marginTop: 10 }}>
              <Badge variant={store.is_active ? 'success' : 'error'} dot>{store.is_active ? 'Активен' : 'Неактивен'}</Badge>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
